module.exports = __webpack_public_path__ + "static/media/cela.46a228da.jpg";